import {BaseAddressUnDeletable} from '../../../common/entities';

export class Campus extends BaseAddressUnDeletable {
     name: string;
}
